$(document).ready(function () {

    $(".browser--click").on('click', function() {
        let this_card = $(this);
        $(this).addClass('animate--card');
        setTimeout(function() { 
            // console.log($(this));
            $(this_card).removeClass('animate--card');
        }, 5000);
    });
    resizeCTA();
    // cardHeadHeight();

    $(window).on('resize', function () {
        // cardHeadHeight();
        resizeCTA();
    });


});



function resizeCTA() {
    $('.cta--inner--card').each(function () {
        var width = $(this).find('.bottom').width();
        if ($(window).width() < 1025) {
            var finalwidth = width;
         } else {
            var finalwidth = width + 66;
         }
        
        var lead = $(this).find('.top').css('maxWidth', finalwidth);
    });
}

// function cardHeadHeight() {
//     // var x = Array.from(document.querySelectorAll(".cards--lg--contact .headline--block")).map(e => $(e).height());
//     // var maxValueInArray = Math.max.apply(Math, x);

//     // console.log(maxValueInArray);

//     $('.cards--lg--contact').each(function () {
//         var maxValueInArray = $(this).find('.headline--block').height();
//         if ($(window).width() > 1024) {
//             $(this).find('.headline--block').css('height', maxValueInArray);
//          } else {
            
//          }

//          console.log(maxValueInArray);
        
//     });
// }